export const postMagazineLeadAdWidth = 300;
export const postMagazineLeadColumnGap = 40;
export const postMagazineLeadDividerWidth = 1;
